module.exports = __WEBPACK_EXTERNAL_MODULE__cognite_cdf_route_tracker__;